module.exports = __webpack_public_path__ + "img/12CH_CT.b8386d94.png";